<header id="header" class="fixed-top">
  <div class="container">
    <div class="logo float-left">
      <a class="navbar-brand" [routerLink]="['/']" rel="tooltip"
         title="Coded by Iruobe Akhigbe" data-placement="bottom">
        <div class="diff">
          <span class="colorChange">College</span>Dreams
        </div>
      </a>
    </div>
    <nav class="main-nav float-right d-none d-lg-block">
      <ul>
        <li>
          <a [routerLink]="['/']">
            About
          </a>
        </li>
        <li>
          <a [routerLink]="['/']">
            Features
          </a>
        </li>
        <li>
          <a href="javascript:void(0)" (click)="scrollToContact()">
            Contact
          </a>
        </li>
        <li>
          <a class="loginbutton" [routerLink]="['/login']" target="_blank">
            <i class="fas fa-sign-in-alt"></i>
            &nbsp; Login
          </a>
        </li>
      </ul>
    </nav>
  </div>
</header>

<div class="page-header header-filter" data-parallax="true" style="background-image:
url('../../../../assets/img/pexels.jpeg'); height: 983px">
  <div class="container">
    <div class="row form-div">
      <div class="col-md-12">
        <h4 class="title text-center">
          <a style="color: #ffffff;" [routerLink]="['/']"> Home </a>
          <i class="fas fa-angle-double-right"></i>
          <a style="color: #ffffff;" [routerLink]="['/online-admissions']">  Online Admissions </a>
          <i class="fas fa-angle-double-right"></i>
          Preview Admission Details
        </h4>
        <h2 class="text-center">
          Apply for admission into any school <br> of your choice.
        </h2>
        <div class="col-lg-6 col-md-6 col-sm-6 ml-auto mr-auto">
          <div class="card form-box">
            <form novalidate  #loginForm="ngForm" (ngSubmit)="goToPaymentsPage()">
              <div class="card-body">
                <!--<span class="font-weight-bold red">{{ errorMessage | titlecase }}</span>-->
                <!--Select School-->
                  <div class="list-group list-group-unbordered mb-3">
                    <div class="list-group-item">
                      <h3 class="">Preview</h3>
                      <a class="edit-content" (click)="goBackToAdmissionsPage()">
                        <h3 class="text-right">
                          Edit
                        </h3>
                      </a>
                    </div>
                    <div class="list-group-item">
                      <b class="float-left">Select School:</b>
                      <a class="float-right" *ngIf="credentials">
                        {{getObjectById(credentials?.schools, schools)?.schoolName}}
                      </a>
                    </div>
                    <div class="list-group-item">
                      <b class="float-left">Student Name:</b>
                      <a class="float-right" *ngIf="credentials">
                        {{credentials?.StudentName}}
                      </a>
                    </div>
                    <div class="list-group-item">
                      <b class="float-left">Date Of Birth:</b>
                      <a class="float-right" *ngIf="credentials">
                        {{credentials?.DateOfBirth}}
                      </a>
                    </div>
                    <div class="list-group-item">
                      <b class="float-left">Previous School:</b>
                      <a class="float-right" *ngIf="credentials">
                        {{credentials?.PreviousSchool}}
                      </a>
                    </div>
                    <div class="list-group-item">
                      <b class="float-left">Previous Class:</b>
                      <a class="float-right" *ngIf="credentials">
                        {{credentials?.PreviousClass}}
                      </a>
                    </div>
                    <div class="list-group-item">
                      <b class="float-left">New Class:</b>
                      <a class="float-right" *ngIf="credentials">
                        {{credentials?.NewClass}}
                      </a>
                    </div>
                  </div>
                <!--Student Name
                <div class="bmd-form-group pb-3">
                  <div class="input-group">
                    <div class="input-group-prepend">
                    </div>
                    <input type="text" class="form-control" placeholder="  Student Name"
                           #StudentName="ngModel" id="StudentName"
                           [(ngModel)]="credentials.StudentName" [ngModelOptions]="{standalone: true}" required autocomplete="false">
                    &lt;!&ndash; minlength="4"&ndash;&gt;
                  </div>
                </div>
                &lt;!&ndash;Date Of Birth&ndash;&gt;
                <div class="bmd-form-group pb-3">
                  <div class="input-group">
                    <div class="input-group-prepend">
                    </div>
                    <input type="text" class="form-control " placeholder="  Date Of Birth" #password="ngModel"
                           id="DateOfBirth" [(ngModel)]="credentials.DateOfBirth" [ngModelOptions]="{standalone: true}" required autocomplete="false">
                    &lt;!&ndash; minlength="8"&ndash;&gt;
                  </div>
                </div>
                &lt;!&ndash;Previous School&ndash;&gt;
                <div class="bmd-form-group pb-3">
                  <div class="input-group">
                    <div class="input-group-prepend">
                    </div>
                    <input type="text" class="form-control " placeholder="  Previous School" #password="ngModel"
                           id="PreviousSchool" [(ngModel)]="credentials.PreviousSchool" [ngModelOptions]="{standalone: true}" required autocomplete="false">
                    &lt;!&ndash; minlength="8"&ndash;&gt;
                  </div>
                </div>
                &lt;!&ndash;Previous Class&ndash;&gt;
                <div class="bmd-form-group pb-3">
                  <div class="input-group">
                    <div class="input-group-prepend">
                    </div>
                    <input type="text" class="form-control " placeholder="  Previous Class" #password="ngModel"
                           id="PreviousClass" [(ngModel)]="credentials.PreviousClass" [ngModelOptions]="{standalone: true}" required autocomplete="false">
                    &lt;!&ndash; minlength="8"&ndash;&gt;
                  </div>
                </div>
                &lt;!&ndash;New Class&ndash;&gt;
                <div class="bmd-form-group pb-3">
                  <div class="input-group">
                    <div class="input-group-prepend">
                    </div>
                    <input type="text" class="form-control " placeholder="  New Class" #password="ngModel"
                           id="NewClass" [(ngModel)]="credentials.NewClass" [ngModelOptions]="{standalone: true}" required autocomplete="false">
                    &lt;!&ndash; minlength="8"&ndash;&gt;
                  </div>
                </div>-->
              </div>
              <div class="card-footer justify-content-center">
                <button type="submit" class="preview-button mt-2">
                  <!--<button type="submit" class="btn btn-warning btn-lg" [disabled]="password.errors || email.errors || loading">-->
                  <i class="fa fa-spinner fa-spin" *ngIf="loading"></i>
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-sign-up2></app-sign-up2>
